import React from 'react';
import styled, { css } from 'styled-components';

const headlineSizes = {
  h1: css`
    margin: 0 0 var(--distance-4xs);
    text-transform: uppercase;
    font-family: var(--font-family-camel);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-xl);
    line-height: 1;
  `,
  h2: css`
    margin: 0;
    font-family: var(--font-family-graphik);
    text-transform: unset;
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  `,
  h3: css`
    margin: 0;
    font-family: var(--font-family-graphik);
    font-weight: var(--font-weight-regular);
    text-transform: uppercase;
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  `,
} as const;
type HeadlineSize = keyof typeof headlineSizes;

interface HeadlineProps {
  className?: string;
  label: string;
  error?: boolean;
  as?: HeadlineSize;
}

interface StyledHeadlineProps {
  $error?: boolean;
  $level: HeadlineSize;
}

const StyledHeadline = styled.div<StyledHeadlineProps>`
  ${({ $level }) => headlineSizes[$level]}
  ${({ $error }) =>
    $error &&
    css`
      color: var(--color-headline-error);
    `}
`;

const Headline = ({ className, label, error, as = 'h1' }: HeadlineProps) => {
  return (
    <StyledHeadline as={as} $level={as} $error={error} className={className}>
      {label}
    </StyledHeadline>
  );
};

export default Headline;
